import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=f10a8670&"
import script from "./Topbar.vue?vue&type=script&lang=ts&"
export * from "./Topbar.vue?vue&type=script&lang=ts&"
import style0 from "./Topbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports